<template>
  <div>
    <draggable v-model="institutes" :element="'div'" :options="{handle:'.handle'}">
      <div class="bg-transparent" v-for="(institute) in institutes" v-bind:key="institute.id">
        <div class="row row-hover">
          <div class="col-1 d-sm-none d-flex">
            <icon :icon="['fad', 'bars']" class="text-info handle" v-if="mode.confirm != true"/>&nbsp;
          </div>
          <div class="col trimText">
            <icon :icon="['fad', 'bars']" class="text-info handle d-none d-sm-inline" v-if="mode.confirm != true"/>
            &nbsp;
            <template v-if="errorInstitutes.includes(institute.id)">
              <template v-if="mode.confirm != true">
                <router-link class="pointer-click"
                             :to="'authors/author/' + institute.author_id + '/institute/'+institute.id+'/edit'">
                  <icon :icon="['fad', 'exclamation-triangle']"
                        class="fa-1x text-danger mx-auto"/>
                </router-link>
              </template>
              <template v-else>
                <icon :icon="['fad', 'exclamation-triangle']"
                      class="fa-1x text-danger mx-auto"/>
              </template>
            </template>

            <template v-if="mode.confirm != true">
              <router-link class="pointer-click"
                           :to="'authors/author/' + institute.author_id + '/institute/'+institute.id+'/edit'">
                {{ institute.name }}<span class="" v-if="institute.department">, {{ institute.department }}</span>
                <span class="" v-if="institute.city">, {{ institute.city }}</span>
                <span class="" v-if="institute.country_code">, {{ wording[0].country[institute.country_code] }}</span>
              </router-link>
            </template>
            <template v-else>
              {{ institute.name }}<span class="" v-if="institute.department">, {{ institute.department }}</span>
              <span class="" v-if="institute.city">, {{ institute.city }}</span>
              <span class="" v-if="institute.country_code">, {{ wording[0].country[institute.country_code] }}</span>
            </template>
          </div>
          <div class="col-3 col-sm-2 col-xl-1 d-flex">
            <template v-if="mode.confirm != true">
              <router-link class="pointer-click"
                           :to="'authors/author/' + institute.author_id + '/institute/'+institute.id+'/edit'">
                <icon :icon="['fad', 'pencil-alt']" class=""/>
              </router-link>
              <div class="pointer-click ml-2"
                   v-if="institutes.length > 1"
                   v-on:click="$store.dispatch('DELETE_INSTITUTE', {institute_id: institute.id, abstract_id: $route.params.id})">
                <icon :icon="['fad', 'trash-alt']" class="text-danger"/>
              </div>
              <div class="pointer-click ml-2" v-else>
                <icon :icon="['fad', 'trash-alt']" class="disabled"/>
              </div>
            </template>
          </div>
        </div>
      </div>
    </draggable>
    <!--Hier fehlt nen unfug autorid-->
    <template v-if="mode.confirm != true">
      <router-link :to="'authors/author/' + author_id + '/institute/add'">
        <div class="row pt-1 row-hover">
          <div class="col d-flex pointer-click">
            <icon class="" :icon="['fas', 'plus-circle']"/>&nbsp;
            <span class="">{{ _[0].buttons.add }}</span>
          </div>
        </div>
      </router-link>
    </template>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import {mapState, mapActions} from 'vuex'

export default {
  name: 'InstituteList',
  props: {
    author_id: 0
  },
  data() {
    return {
      errorInstitutes: [],

    };
  },
  async created() {
    await this.integrityCheck();
  },
  components: {
    draggable,
  },
  computed: {
    ...mapState([
      'settings', 'wording', 'abstract', 'authors', 'mode'
    ]),
    institutes: {
      get() {
        let institute = this.authors.find(author => author.id === this.author_id).institute
        if (!institute) {
          institute = {};
        }
        return institute;
      },
      set(listing) {
        listing.forEach((element, index) => {
          element.order = index + 1;
          this.updateInstitute(element);
        });
        let author = this.authors.find(author => author.id === this.author_id);
        this.$set(author, 'institute', listing);
      }
    }
  },
  methods: {
    ...mapActions([
      'PUT_INSTITUTE', 'VALIDATE_INTEGRITY_AUTHOR'
    ]),
    async updateInstitute(element) {
      await this.PUT_INSTITUTE({template: {order: element.order}, id: element.id}).then((result) => {
        this.$store.dispatch('GET_AFFILIATIONS', this.$route.params.id);
        this.$noty.success(this.wording[0].notify.save_success);
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      })
    },
    async integrityCheck() {
      // await this.VALIDATE_INTEGRITY_AUTHOR(this.author_id).then(async (responseCheck) => {
      //   this.errorInstitutes = responseCheck.data.invalid_institute
      // }).catch((error) => {
      // })
    }
  }
}
</script>
